<app-error-page [errorMsg]="errorMsg" *ngIf="containsError"></app-error-page>
<div class="query-loans-container">
    <div class="pageHeader" id="submitLoanQueryHeader">Submit Loan Query</div>

    <div class="warningMessage" *ngIf="warningMessage">{{warningMessage}}</div>

    <div class="errorMessage" *ngIf="errorMessage?.length">
        You must correct the following error(s) before proceeding:
        <li *ngFor="let message of errorMessage">{{message}}</li>
    </div>

    <form [formGroup]="queryLoanForm" (ngSubmit)= "getLoansKeylist()" >
        <div class="query-loans">
            <div class="ui-g">
                <span class="normal-text u-mt-13">Enter either a</span>
                <div class="ui-g-1 lableright glypha-font"> Loan Number: </div>
                <div class="ui-g-2"><input type="text" fmTextInput id="loanNumber" formControlName="loanNumber" [maxlength]="10"></div>
              <div class="ui-g-3 lableright glypha-font">
                <label class="u-fw-normal">Or</label> FHA Case Number:</div>
                <div class="ui-g-2"><input type="text" fmTextInput formControlName="fhaCaseNumber"  [maxlength]="10"></div>
                <div class="dropdown-text">
                    <fm-select [options]='fhaExt' ariaLabelledBy="default"></fm-select>
                </div>
            </div>
            <div class="ui-g">
                <span class="u-ml-100-mt-12"><label class="u-fw-normal">Or</label></span>
                <div class="ui-g-3 lableright glypha-font"> Lender Loan ID:</div>
                <div class="ui-g-2"><input type="text" fmTextInput formControlName="lenderLoanNumber" [maxLength]="15"></div>
            </div>
            <div class="search-criteria-text">
                <span class="normal-text">or any combination of the following attributes:</span>
            </div>

            <div class="ui-g"  *ngIf="!isExternal">
                <div class="ui-g-3 lableright glypha-font">Servicer Number:</div>
                <div class="ui-g-3"><input type="text" fmTextInput formControlName="servicerNumber"  [maxLength]="9"></div>
            </div>
          <div class="ui-g" *ngIf="isExternal">
            <div class="ui-g-3 lableright glypha-font">Servicer Number:</div>
            <div class="ui-g-3">

              <div class="select-style">
                <fm-select [options]="serNumber" ariaLabelledBy="default"
                           formControlName="servicerNumber"></fm-select>
              </div>
            </div>
          </div>



            <div class="ui-g">
                <div class="ui-g-3 lableright glypha-font">Loan Status:</div>
                <div class="ui-g-3">
                    <div class="select-style">
                        <fm-select [options]="loanStatus" ariaLabelledBy="default"
                            formControlName="loanStatus"></fm-select>
                    </div>
                </div>
                <div class="ui-g-3 lableright glypha-font">Scheduled Payment Status:</div>
                <div class="ui-g-3">
                    <div class="select-style">
                        <fm-select [options]="paymentStatus"
                            ariaLabelledBy="default" formControlName="paymentStatus"></fm-select>
                    </div>
                </div>
            </div>
            <div class="ui-g">
                <div class="ui-g-3 lableright glypha-font"> Payment Plan:</div>

                <div class="ui-g-3">
                    <div class="select-style">
                        <fm-select [options]="paymentPlan" ariaLabelledBy="default"
                            formControlName="paymentPlan"></fm-select>
                    </div>
                </div>
                <div class="ui-g-3 lableright glypha-font"> Product Type:</div>
                <div class="ui-g-3">
                    <div class="select-style">
                        <fm-select [options]="productType" ariaLabelledBy="default"
                            formControlName="productType"></fm-select>
                    </div>
                </div>
            </div>
            <div class="search-criteria-text">
                <span class="selecton-text glypha-font">Purchase Date Range:</span>
                <div class="ui-g">
                    <div class="ui-g-3 lableright glypha-font"> from:</div>
                    <div class="ui-g-3">
                        <fm-calendar formControlName="purchaseDateStart" [monthNavigator]="true" [yearNavigator]="true" [yearRange]="('1990:2050')"
                                     placeholder="MM/DD/YYYY" [showClear]="true"></fm-calendar>
                    </div>
                    <div class="ui-g-3 lableright glypha-font"> to:</div>
                    <div class="ui-g-3">
                        <fm-calendar formControlName="purchaseDateEnd" [monthNavigator]="true" [yearNavigator]="true" [yearRange]="('1990:2050')"
                                     placeholder="MM/DD/YYYY" [showClear]="true">
                        </fm-calendar>
                    </div>
                </div>
            </div>


            <div class="search-criteria-text">
                <span class="selecton-text glypha-font">Funding Date Range:</span>


                <div class="ui-g">
                    <div class="ui-g-3 lableright glypha-font"> from:</div>
                    <div class="ui-g-3">
                        <fm-calendar formControlName="fundingDateStart" [monthNavigator]="true" [yearNavigator]="true" [yearRange]="('1990:2050')"
                                     placeholder="MM/DD/YYYY" [showClear]="true"></fm-calendar>
                    </div>
                    <div class="ui-g-3 lableright glypha-font"> to:</div>
                    <div class="ui-g-3">
                        <fm-calendar formControlName="fundingDateEnd" [monthNavigator]="true" [yearNavigator]="true" [yearRange]="('1990:2050')"
                                     placeholder="MM/DD/YYYY" [showClear]="true">
                        </fm-calendar>
                    </div>
                </div>
            </div>
            <div class="search-criteria-text">
                <span class="selecton-text glypha-font">Interest Rate Range:</span>
            </div>

            <div class="ui-g">
                <div class="ui-g-3 lableright glypha-font"> between:</div>
                <div class="ui-g-3">
                    <input type="text" formControlName="interestRateStart" >
                </div>
                <div class="ui-g-3 lableright glypha-font"> and:</div>
                <div class="ui-g-3">
                    <input type="text" formControlName="interestRateEnd" >
                </div>
            </div>

            <div class="search-criteria-text">
                <span class="selecton-text glypha-font">Loan Balance Range:</span>
            </div>

            <div class="ui-g">
                <div class="ui-g-3 lableright glypha-font"> between:</div>
                <div class="ui-g-3">
                    <input type="text" formControlName="loanBalanceStart" >
                </div>
                <div class="ui-g-3 lableright glypha-font"> and:</div>
                <div class="ui-g-3">
                    <input type="text" formControlName="loanBalanceEnd" >
                </div>
            </div>

            <div class="ui-g">
                <div class="ui-g-6">
                    <button fmButton type="submit" [primary]="true" [small]="true" label="Submit"
                         class="buttonmargin"></button>
                    <button fmButton type="button" label="Clear" [small]="true" (click)="onClear()"
                        class="buttonmargin"></button>
                    <button fmButton type="button" label="Cancel" [small]="true" routerLink="/reverseMortgage"
                        class="buttonmargin"></button>
                </div>
            </div>
        </div>
    </form>
</div>
